"use client"

import { useRouter } from "next/navigation"
import { useState } from "react"
import { logoutUser } from "../lib/api-client.ts"
import { ActionFeedbackSheet } from "./action-feedback-sheet.tsx"

export const LogoutControl = () => {
  const router = useRouter()
  const [message, setMessage] = useState("")
  const [pending, setPending] = useState(false)

  const logout = async (): Promise<void> => {
    if (pending) return
    setPending(true)
    setMessage("")
    try {
      const result = await logoutUser()
      if (result === "failed") {
        setMessage("로그아웃하지 못했습니다. 로그인 상태는 유지됩니다. 잠시 후 다시 시도해 주세요.")
        return
      }
      router.replace("/login")
      router.refresh()
    } finally {
      setPending(false)
    }
  }

  return (
    <div className="action-area">
      <button aria-busy={pending} className="button secondary" disabled={pending} onClick={() => void logout()} type="button">
        로그아웃
      </button>
      <ActionFeedbackSheet message={message} onClose={() => setMessage("")} title="로그아웃을 완료하지 못했어요" />
    </div>
  )
}
